import React, { useEffect, useState, useContext } from 'react';
import { Link, useNavigate, useLocation } from "react-router-dom";
import "../components/Topbar/topbar.css";
import "../components/Lms/lms.css";

import { lmsConfirm } from '../components/Lms/LmsDialog';
import { clearLmsAccess, getLmsAccess, isSubAdmin } from '../components/Lms/lmsAccess';

import { Context } from './../Auth.Context';



const Topbar = ({ handleSidebar }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const isLms = location.pathname.startsWith("/lms");
    // an LMS sub admin can't open the other admin screens, so no Admin tab
    const lmsOnly = isSubAdmin();

    const [adminDetails, setAdminDetails] = useContext(Context);
    // sub_admin is greeted as Admin, admin as Super Admin (older logins have no role saved, fall back to the LMS role)
    const role = getLmsAccess()?.role;
    let roleLabel = "";
    if (role === "super_admin") {
        roleLabel = "Super Admin";
    } else if (role === "sub_admin") {
        roleLabel = "Admin";
    }

    async function Logout(e) {
        if (e) e.preventDefault();

        const confirmed = await lmsConfirm({
            title: "Log out?",
            message: "You'll need to sign in again to use the admin panel.",
            confirmLabel: "Log out",
            cancelLabel: "Cancel",
        });
        if (confirmed) {
            setAdminDetails({});
            localStorage.removeItem("admin_details");
            localStorage.removeItem("token");
            localStorage.removeItem("auth_roles");
            clearLmsAccess();
            window.location.href="/login";
        }
    }// end Logout()



    return (
        <>

            <nav className={`navbar navbar-main navbar-expand-lg border-bottom topbar d-block d-sm-none p-3 ${isLms ? "lms-topbar" : ""}`}>
                <li className="nav-item ps-3 d-flex align-items-center"
                    onClick={handleSidebar}
                    style={{ cursor: "pointer" }}
                >
                    <span className="nav-link text-body p-0">
                        <div className="sidenav-toggler-inner">
                            <i className="sidenav-toggler-line" />
                            <i className="sidenav-toggler-line" />
                            <i className="sidenav-toggler-line" />
                        </div>
                    </span>
                </li>
                <div className="header-switch ml-auto mr-0">
                    {!lmsOnly && <Link to="/" className={isLms ? "" : "active"}>Admin</Link>}
                    <Link to="/lms" className={isLms ? "active" : ""}>LMS</Link>
                </div>
                {/* <li className="navbar-brand m-0 d-flex justify-content-center align-items-center">
          <img
            src="/img/moneymatchlogo.png"
            className="resp-logo"
            alt="Logo"
          />
        </li> */}

                {/* <div className="navbar-brand m-0 d-flex justify-content-center align-items-center">
          
        </div> */}
            </nav>




            <nav className={`navbar navbar-main navbar-expand-lg border-bottom topbar d-none d-sm-block ${isLms ? "lms-topbar" : ""}`}>
                <div className="container-fluid py-1 px-3">
                    {/* <div
                        className="d-none d-lg-inline text-white"
                        style={{ fontSize: "17px", textTransform: "capitalize" }}
                    >
                        Hi, Admin
                    </div> */}
                    <div className="collapse navbar-collapse mt-sm-0 mt-2 ml-auto" style={{ flexGrow: "unset" }}>
                        <ul className="navbar-nav justify-content-end">
                            <li className="nav-item d-flex align-items-center">
                                <div className="header-switch">
                                    {!lmsOnly && <Link to="/" className={isLms ? "" : "active"}>Admin</Link>}
                                    <Link to="/lms" className={isLms ? "active" : ""}>LMS</Link>
                                </div>
                            </li>
                            <li className="nav-item d-flex align-items-center">
                                <Link to="/" className="nav-link text-body text-white" style={{ textDecoration: "none" }}>
                                    {/* <img
                    src="/img/moneymatchimg.png"
                    className="navbar-brand-img h-100 w-13"
                    alt="Logo"
                    width="30px"
                  /> */}
                                    <span style={{ fontSize: "15px" }} className="d-inline text-white mr-5 hdr-greet">
                                        Hi , {roleLabel}
                                    </span>
                                    <span style={{ fontSize: "15px" }} className="d-inline text-white ml-1 hdr-logout" onClick={(e) => Logout(e)}>
                                        Log out
                                    </span>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </>
    );
};

export default Topbar;
